var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommunityPostSettings, PostRepository, PostTargetType } from '@amityco/js-sdk';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { notification } from '../../../../core/components/Notification';
import promisify from '../../../../helpers/promisify';
export const MAX_IMAGES = 10;
export const MAX_FILES = 10;
export const getAuthorId = ({ communityId, userId } = {}) => communityId || userId;
export const isIdenticalAuthor = (a, b) => !!getAuthorId(a) && getAuthorId(a) === getAuthorId(b);
export const maxImagesWarning = () => notification.info({
    content: 'You reached the maximum attachment of 10',
});
export const maxFilesWarning = () => notification.info({
    content: 'The selected file is larger than 1GB. Please select a new file. ',
});
export function createPost({ targetId, targetType, data, dataType, attachments, mentionees, metadata, }) {
    return __awaiter(this, void 0, void 0, function* () {
        return promisify(PostRepository.createPost({
            targetId,
            targetType,
            data,
            dataType,
            attachments,
            mentionees,
            metadata,
        }));
    });
}
/**
 * Some users (moderators, etc) can publish posts without premoderation even
 * if premoderation is turned off. Here we check if the post is moved to reviewing feed.
 * If so, show the message to user
 */
export function showPostCreatedNotification(post, community) {
    return __awaiter(this, void 0, void 0, function* () {
        if (post.targetType === PostTargetType.CommunityFeed &&
            community.postSetting === CommunityPostSettings.ADMIN_REVIEW_POST_REQUIRED &&
            post.feedId === community.reviewingFeed.feedId) {
            notification.success({ content: React.createElement(FormattedMessage, { id: "post.success.submittedToReview" }) });
        }
    });
}
//# sourceMappingURL=utils.js.map